export const LEGAL_POLICY_LINKS = {
  PRIVACY_POLICY_URL_PDF:
    "https://d2d43icoh366od.cloudfront.net/mentor-collective-platform-privacy-policy-20210713-1.pdf",
  PRIVACY_POLICY_URL_HTML:
    "https://d2d43icoh366od.cloudfront.net/mentor-collective-platform-privacy-policy-20210713-2.html",
  TERMS_OF_USE_URL_PDF:
    "https://d2d43icoh366od.cloudfront.net/mentor-collective-platform-terms-of-use-20210713.pdf",
  TERMS_OF_USE_URL_HTML:
    "https://d2d43icoh366od.cloudfront.net/mentor-collective-platform-terms-of-use-20210713-2.html",
};
